// DS1.7.5
import React from 'react';
import classnames from 'classnames';
import { Url } from '@wix/da-url';
import s from './ThumbStatusIndicator.scss';
var validCombinations = {
    'in-tier': ['large', 'medium', 'small'],
    'in-premium': ['large', 'medium'],
    'in-watchers-only': ['large', 'medium'],
    pcp: ['medium'],
    nft: ['medium'],
};
var fileNameMap = {
    'in-tier': 'tier',
    'in-premium': 'pg',
    'in-watchers-only': 'watchers',
};
var ThumbStatusIndicator = function (_a) {
    var _b;
    var type = _a.type, size = _a.size, className = _a.className;
    // not all combinations exist
    if (!validCombinations[type].includes(size)) {
        return null;
    }
    return (React.createElement("div", { className: classnames(s['root'], s[size], className) },
        React.createElement("img", { alt: "", className: s['image'], src: Url.staticCDNLink("eclipse/global/svg/deviation-status-icons/".concat((_b = fileNameMap[type]) !== null && _b !== void 0 ? _b : type, "-").concat(size, ".svg")) })));
};
ThumbStatusIndicator.displayName = 'ThumbStatusIndicator';
export default ThumbStatusIndicator;
//# sourceMappingURL=ThumbStatusIndicator.js.map